import axios from 'axios';
import { objectToQuery } from 'common/helpers/filters.helper';
import {
  IGroupCollection,
  IGroupCollectionFilter,
  IGroupCreateData,
  IGroupModel,
  IGroupUpdateData,
  IRegionCollection,
  IRegionCollectionFilter,
  IRegionCreateData,
  IRegionModel,
  IRegionUpdateData,
} from 'entities/Region/Region.models';

const regionsPath = '/regions';
const groupsPath = '/groups';

export const regionTransport = {
  getRegionCollection: (filter?: IRegionCollectionFilter): Promise<IRegionCollection> =>
    axios.get(`${regionsPath}${objectToQuery(filter)}`),
  addRegion: (params: IRegionCreateData): Promise<IRegionModel> => axios.post(regionsPath, params),
  updateRegion: ({ id, ...rest }: IRegionUpdateData): Promise<IRegionModel> => axios.patch(`${regionsPath}/${id}`, rest),
  deleteRegion: (id: string): Promise<void> => axios.delete(`${regionsPath}/${id}`),

  getGroupCollection: (filter?: IGroupCollectionFilter): Promise<IGroupCollection> =>
    axios.get(`${groupsPath}${objectToQuery(filter)}`),
  addGroup: (params: IGroupCreateData): Promise<IGroupModel> => axios.post(groupsPath, params),
  updateGroup: ({ id, ...rest }: IGroupUpdateData): Promise<IGroupModel> => axios.patch(`${groupsPath}/${id}`, rest),
  deleteGroup: (id: string): Promise<void> => axios.delete(`${groupsPath}/${id}`),
};
